import { createContext, useContext } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import { ProductPlanFormModelContext } from "../../_shared/context/context";

import type { ProductPlanFormModelContextType } from "../../_shared/context/context";

export type ProductExistingPlanFormModelContextType = {
	onUpdate: () => void;

	testEmailSender: {
		sendTestMailAtReservationCreate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationUpdate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationCancel: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore07Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore00Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckOutAfter01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
	};
} & ProductPlanFormModelContextType;

export const ProductExistingPlanFormModelContext = createContext<ProductExistingPlanFormModelContextType | null>(null);

export const ProductExistingPlanFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductExistingPlanFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductExistingPlanFormModelContext.Provider value={value}>
			<ProductPlanFormModelContext.Provider value={value}>{children}</ProductPlanFormModelContext.Provider>
		</ProductExistingPlanFormModelContext.Provider>
	);
};

export const useProductExistingPlanFormModelContext = () => {
	const context = useContext(ProductExistingPlanFormModelContext);

	if (!context) {
		throw new Error(
			"useProductExistingPlanFormModelContext must be used within a ProductExistingPlanFormModelContextProvider",
		);
	}

	return context;
};
